import React from 'react'
import { Formik } from 'formik'
import { login } from '../actions/auth'
import { connect } from 'react-redux'
import { withRouter, Redirect, Link } from 'react-router-dom'
import { CSSTransition } from "react-transition-group"
import EncrpytedInput from './encryptedInput'
import {BrowserView,MobileView,isBrowser,isMobile} from 'react-device-detect';

const Login = ({ auth, dispatch }) => {
    let date = new Date()
    let year = date.getFullYear();
    return (
        <div>
            <div className="excelym-theme-bar"></div>
            <CSSTransition
                in={true}
                appear={true}
                timeout={5000}
                classNames="fade"
            >
                <div className="center-wrapper">

                    <div className="center-div">
                        {
                            auth.authenticated ?
                                <Redirect to='/' /> :
                                <Formik
                                    initialValues={{ Password: 'asdf', Email: '', rememberme: true }}
                                    onSubmit={values => {
                                        dispatch(login(values))
                                    }}

                                    render={({
                                        handleSubmit,
                                        handleChange,
                                        values
                                    }) => (
                                            <div className="login-view-wrapper">
                                                <form
                                                    className=""
                                                    onSubmit={handleSubmit}
                                                >
                                                    <div className="official-logo login-section">
                                                        <div className="animation-wrapper">
                                                            <div className="fa-animation">
                                                                <i className="fa fa-cog fa-lg fa-spin"></i>
                                                                <i className="fa fa-cog fa-md fa-spin"></i>
                                                                <i className="fa fa-cog fa-xs fa-spin"></i>


                                                            </div>
                                                            <div className="ml-5">
                                                                <span className="" style={{ color: '#0FB8DB', fontSize: '1.2rem', display: 'block', marginLeft: '1rem' }}>Excelym <strong style={{ color: '#125EAC' }}>IO</strong></span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <CSSTransition
                                                        in={true}

                                                        timeout={5000}
                                                        classNames="fade"
                                                    >
                                                        <div className='form-group login'>
                                                            <div className={`col s12 waves-effect ${auth.error ? ' error-msg pulse' : ''}`}>
                                                                <span className=''>{auth.error}</span>
                                                            </div>
                                                        </div>
                                                    </CSSTransition>
                                                    <div className='form-group login'>

                                                        <EncrpytedInput
                                                            className='form-control'
                                                            type='email'
                                                            name='email'
                                                            id='email'
                                                            onChange={handleChange}
                                                            value={values.email}
                                                            placeholder='Email'
                                                        />
                                                    </div>
                                                    <div className='form-group login'>

                                                        <EncrpytedInput
                                                            className="form-control"
                                                            type='password'
                                                            name='password'
                                                            id='password'
                                                            onChange={handleChange}
                                                            value={values.password}
                                                            placeholder='Password'
                                                        />
                                                    </div>
                                                    <center>
                                                        <div className='form-group login mt-3'>
                                                            <button
                                                                type='submit'
                                                                name='btn_login'
                                                                className='btn'
                                                            >
                                                                <span>Login </span>
                                                            </button>
                                                        </div>
                                                    </center>
                                                    <div className='form-check form-check-inline mt-2 float-left'>
                                                            <input type="checkbox" name="rememberme" id="rememberme" checked={values['rememberme']} onChange={handleChange} />
                                                            <label className="form-check-label ml-2" htmlFor="rememberme"> Remember me</label>
                                                    </div>
                                                    <div className='forgot-password-link mt-2  float-right'>
                                                        <Link to='/forgot-password'>
                                                            <span className="forgot-password ">
                                                                Forgot Password?
                                                            </span>
                                                        </Link>
                                                    </div>
                                                </form>
                                            </div>
                                        )}
                                />
                        }
                        <div className="d-flex justify-content-center mt-1">
                            <p className="copyright">excelym.io &copy; {year}</p>
                        </div>
                    </div>
                </div></CSSTransition>
        </div>//End of entire wrapping Div

    )
}

function mapStateToProps(state) {
    return {
        auth: state.auth
    }
}

export default withRouter(connect(mapStateToProps)(Login))


// WEBPACK FOOTER //
// ./src/components/login.js